import event from '../../event/event';

export default event('/workflow/deleted');
